import {
  FETCH_PERFORMER_EARNINGS_START,
  FETCH_PERFORMER_EARNINGS_SUCCESS,
  FETCH_PERFORMER_EARNINGS_FAILURE,
  TOTAL_GET_F2F_PACKAGES,
  FACE2FACE_EDIT_PACKAGE_START,
  FACE_TO_FACE_PACKAGE_SUCCESS,
  FACE_TO_FACE_PACKAGE_FAILURE,
  FACE2FACE_EDIT_PACKAGE_SUCCESS,
  FACE2FACE_EDIT_PACKAGE_FAILURE,
  CREATE_PACKAGES,
  FACE_2_FACE_CREATE_PACKAGE_SUCESS,
  FACE_2_FACE_CREATE_PACKAGE_FAILURE,
  DELETED_PACKAGES,
  FACE_TO_FACE_DELTE_PACKAGE_FAILURE,
  FACE_TO_FACE_DELTE_PACKAGE_SUCCESS,
  FACE_2_FACE_SESSION,
  FACE_TO_FACE_SESSION_FAILURE,
  FACE_TO_FACE_SESSION_SUCCESS,
  FACE_2_FACE_SESSION_CREATE,
  FACE_2_FACE_SESSIONCREATE_SUCCESS,
  FACE_2_FACE_SESSION_FAILURE,
  FACE_2FACE_PACKGE_FOR_USER,
  FACE_2FACE_PACKGE_FOR_USER_SUCCESS,
  FACE_2FACE_PACKGE_FOR_USER_FAILURE,
  GET_SINGLE_SESSION,
  GET_SINGLE_SESSION_SUCCESS,
  GET_SINGLE_SESSION_FAILURE,
  FACE_TO_FACE_PACKAGE_DISCOUNT,
  FACE_TO_FACE_PACKAGE_DISCOUNT_SUCCESS,
  FACE_TO_FACE_PACKAGE_DISCOUNT_FAILURE,
  SHOW_FACE2FACE_PACKAGE_SELECTION,
  HIDE_FACE2FACE_PACKAGE_SELECTION,
  FACE_2_FACE_SEND_TIP,
  FACE_2_FACE_SEND_TIP_SUCCESS,
  FACE_2_FACE_SEND_TIP_FAILURE,
  FACE_TO_FACE_CALL_HISTORY,
  FACE_TO_FACE_CALL_HISTORY_SUCCESS,
  FACE_TO_FACE_CALL_HISTORY_FAILURE,
  FETCH_F2F_PENDING_CALLS_START,
  FETCH_F2F_PENDING_CALLS_SUCCESS,
  FETCH_F2F_PENDING_CALLS_FAILURE,
} from './ActionConstant';

// Face2Face Earnings
export function fetchF2FPerformerEarningsStart(data) {
  return {
    type: FETCH_PERFORMER_EARNINGS_START,
    data,
  };
}

export function fetchF2FPerformerEarningsSuccess(data) {
  return {
    type: FETCH_PERFORMER_EARNINGS_SUCCESS,
    data,
  };
}

export function fetchF2FPerformerEarningsFailure(data) {
  return {
    type: FETCH_PERFORMER_EARNINGS_FAILURE,
    data,
  };
}

// Face2Face Pending Calls
export function fetchF2FPendingCallsStart(data) {
  return {
    type: FETCH_F2F_PENDING_CALLS_START,
    data,
  };
}

export function fetchF2FPendingCallsSuccess(data) {
  return {
    type: FETCH_F2F_PENDING_CALLS_SUCCESS,
    data,
  };
}

export function fetchF2FPendingCallsFailure(data) {
  return {
    type: FETCH_F2F_PENDING_CALLS_FAILURE,
    data,
  };
}

// face 2 face packages get
export function face2facepackages(data) {
  return {
    type: TOTAL_GET_F2F_PACKAGES,
    data,
  };
}

export function fetchf2fpackagessuccess(data) {
  return {
    type: FACE_TO_FACE_PACKAGE_SUCCESS,
    data,
  };
}

export function fetchf2fpackagesfailure(error) {
  return {
    type: FACE_TO_FACE_PACKAGE_FAILURE,
    error,
  };
}

// Edit face2face Package
export function editF2FPackageStart(data) {
  return {
    type: FACE2FACE_EDIT_PACKAGE_START,
    data,
  };
}

export function editF2FPackageSuccess(data) {
  return {
    type: FACE2FACE_EDIT_PACKAGE_SUCCESS,
    data,
  };
}

export function editF2FPackageFailure(error) {
  return {
    type: FACE2FACE_EDIT_PACKAGE_FAILURE,
    error,
  };
}

// face to face create packages
export function f2fcreate_pacages(data) {
  return {
    type: CREATE_PACKAGES,
    data,
  };
}

export function createf2fpackages(data) {
  return {
    type: FACE_2_FACE_CREATE_PACKAGE_SUCESS,
    data,
  };
}

export function createf2filure(error) {
  return {
    type: FACE_2_FACE_CREATE_PACKAGE_FAILURE,
    error,
  };
}

//face 2 face get discount created by admin

export function getf2fdiscount(data) {
  return {
    type: FACE_TO_FACE_PACKAGE_DISCOUNT,
    data,
  };
}

export function getf2fdiscountSuccess(data) {
  return {
    type: FACE_TO_FACE_PACKAGE_DISCOUNT_SUCCESS,
    data,
  };
}

export function getf2fdiscountFailure(error) {
  return {
    type: FACE_TO_FACE_PACKAGE_DISCOUNT_FAILURE,
    error,
  };
}

//face 2 face delete packages

export function f2fdeletepackages(data) {
  return {
    type: DELETED_PACKAGES,
    data,
  };
}

export function fetchf2fdeletepackagessuccess(data) {
  return {
    type: FACE_TO_FACE_DELTE_PACKAGE_SUCCESS,
    data,
  };
}

export function fetchf2fdeletepackagesfailure(error) {
  return {
    type: FACE_TO_FACE_DELTE_PACKAGE_FAILURE,
    error,
  };
}

// face 2 face sessions history

export function f2fsession(data) {
  return {
    type: FACE_2_FACE_SESSION,
    data,
  };
}

export function f2fSessioSuccess(data) {
  return {
    type: FACE_TO_FACE_SESSION_FAILURE,
    data,
  };
}

export function f2fSessionFailure(error) {
  return {
    type: FACE_TO_FACE_SESSION_SUCCESS,
    error,
  };
}

export function f2fCallHistory(data) {
  return {
    type: FACE_TO_FACE_CALL_HISTORY,
    data,
  };
}

export function f2fCallHistorySuccess(data) {
  return {
    type: FACE_TO_FACE_CALL_HISTORY_SUCCESS,
    data,
  };
}

export function f2fCallHistoryFailure(error) {
  return {
    type: FACE_TO_FACE_CALL_HISTORY_FAILURE,
    error,
  };
}

// face to face seesion create
export function f2fsession_create(data) {
  return {
    type: FACE_2_FACE_SESSION_CREATE,
    data,
  };
}

export function f2fSession_create_Success(data) {
  return {
    type: FACE_2_FACE_SESSIONCREATE_SUCCESS,
    data,
  };
}

export function f2fSession_create_Failure(error) {
  return {
    type: FACE_2_FACE_SESSION_FAILURE,
    error,
  };
}

export function f2fgte_user_to_performer_packges(data) {
  return {
    type: FACE_2FACE_PACKGE_FOR_USER,
    data,
  };
}

export function f2fgte_user_to_performer_packgesSuccess(data) {
  return {
    type: FACE_2FACE_PACKGE_FOR_USER_SUCCESS,
    data,
  };
}

export function f2fgte_user_to_performer_packgesFailure(error) {
  return {
    type: FACE_2FACE_PACKGE_FOR_USER_FAILURE,
    error,
  };
}

export function f2f_get_single_session(data) {
  return {
    type: GET_SINGLE_SESSION,
    data,
  };
}

export function f2f_get_single_session_success(data) {
  return {
    type: GET_SINGLE_SESSION_SUCCESS,
    data,
  };
}

export function f2f_get_single_session_failure(error) {
  return {
    type: GET_SINGLE_SESSION_FAILURE,
    error,
  };
}

export function showFace2FacePackageSelection(data) {
  return {
    type: SHOW_FACE2FACE_PACKAGE_SELECTION,
    data
  }
}

export function hideFace2FacePackageSelection() {
  return {
    type: HIDE_FACE2FACE_PACKAGE_SELECTION
  }
}

export function f2fSendTipStart(data) {
  return {
    type: FACE_2_FACE_SEND_TIP,
    data,
  };
}

export function f2fSendTipSuccess(data) {
  return {
    type: FACE_2_FACE_SEND_TIP_SUCCESS,
    data,
  };
}

export function f2fSendTipFailure(error) {
  return {
    type: FACE_2_FACE_SEND_TIP_FAILURE,
    error,
  };
}
